import { Button } from '@eventbrite/eds-button';
import { AlertChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import Header from '../../common/Header';
import PrivacyTerms from '../../PrivacyTerms';
import './ToSForm.scss';

export interface IToSFormProps {
    dataTestId: string;
    onCancelToS: () => void;
    onAcceptToS: () => void;
}

const ToSForm = ({ dataTestId, onCancelToS, onAcceptToS }: IToSFormProps) => (
    <div
        className="tos-form eds-fx--fade-in eds-fx--delay-2"
        data-testid={dataTestId}
    >
        <Header
            titleText={gettext('Terms and conditions')}
            iconType={<AlertChunky />}
            subtitleText={<PrivacyTerms />}
            iconColor="ui-700"
            iconBottomSpacing="eds-l-mar-bot-6"
            titleClassName="eds-text-hs eds-l-mar-bot-5"
        />

        <div className="tos-form__actions eds-l-pad-bot-8 eds-align--center">
            <Button
                onClick={onCancelToS}
                type="button"
                __containerClassName="eds-l-mar-right-8"
                data-testid={`${dataTestId}-button-cancel`}
            >
                {gettext('Cancel')}
            </Button>
            <Button
                onClick={onAcceptToS}
                type="button"
                style="fill"
                __containerClassName="eds-l-mar-right-8"
                data-testid={`${dataTestId}-button-accept`}
            >
                {gettext('Agree')}
            </Button>
        </div>
    </div>
);

export default ToSForm;
